import axios from "axios";

export const fetchGetJobsByCompanyId = async (companyId: string) => {
  return await axios.get(`/api/company/job?pageSize=-1&companyId=${companyId}`);
};
